/**
 * Hàng đợi ở trang tra cứu học viên DAT.
 *
 * Trước đây ba thứ này nằm ở ba chỗ khác nhau trên giao diện, dù chúng là cùng
 * một loại: "xem tập học viên nào".
 *   - `Kiểm lần 1` / `Kiểm lần 2` là hai NÚT, trông như thao tác ghi.
 *   - `Chờ phê duyệt` là một CHECKBOX ở hàng dưới, cạnh các bộ lọc hạng khoá.
 *
 * Thực tế cả ba đều chỉ đổi truy vấn, không ghi gì. Và chúng vốn đã loại trừ
 * nhau: bấm `Kiểm lần 1` chạy `searchFirstCheckStudent`, một truy vấn khác hẳn,
 * bỏ qua cờ `onlySubmitted`. Nên gom về một cụm chọn-một là mô tả đúng hành vi
 * đang có, không phải đổi hành vi.
 *
 * Tách ra file riêng vì đây là chỗ dễ sai lặng lẽ: chọn nhầm hàng đợi thì trang
 * vẫn hiện một danh sách học viên trông hợp lý, chỉ là sai tập.
 */

export const HANG_DOI = {
  TAT_CA: 'tat-ca',
  KIEM_1: 'kiem-1',
  KIEM_2: 'kiem-2',
  CHO_DUYET: 'cho-duyet',
};

/** Nhãn hiện trên giao diện. Giữ đúng chữ cũ để người dùng không phải học lại. */
export const NHAN_HANG_DOI = {
  [HANG_DOI.TAT_CA]: 'Tất cả',
  [HANG_DOI.KIEM_1]: 'Kiểm lần 1',
  [HANG_DOI.KIEM_2]: 'Kiểm lần 2',
  [HANG_DOI.CHO_DUYET]: 'Chờ duyệt',
};

/**
 * Hàng đợi nào được phép hiện. `Chờ duyệt` chỉ dành cho người có quyền phê
 * duyệt — trước đây checkbox của nó cũng đã ẩn theo `allowApprove`.
 */
export function hangDoiChoPhep(allowApprove) {
  const chung = [HANG_DOI.TAT_CA, HANG_DOI.KIEM_1, HANG_DOI.KIEM_2];
  return allowApprove ? [...chung, HANG_DOI.CHO_DUYET] : chung;
}

/**
 * Hàng đợi này chạy truy vấn nào.
 *
 * `boLoc` KHÔNG phải cờ bật/tắt, vì hai hàng đợi kiểm không bỏ hết bộ lọc —
 * chúng vẫn mang theo hạng khoá (`searchFirstCheckStudent({ hang })`), chỉ bỏ
 * tên, hạng xe và "đã có phiên". Dùng một boolean ở đây là mô tả sai, và cái
 * sai đó sẽ lặng lẽ đổi tập kết quả:
 *   'day-du'  — mang toàn bộ bộ lọc
 *   'chi-hang'— chỉ mang hạng khoá
 *
 * `phanTrang` cũng khác nhau: hai hàng đợi kiểm trả về danh sách đầy đủ, không
 * chia trang (state `paged` của trang đang phản ánh đúng điều này).
 */
export function truyVanCuaHangDoi(hangDoi) {
  switch (hangDoi) {
    case HANG_DOI.KIEM_1:
      return { kieu: 'kiem-lan-1', boLoc: 'chi-hang', onlySubmitted: false, phanTrang: false };
    case HANG_DOI.KIEM_2:
      return { kieu: 'kiem-lan-2', boLoc: 'chi-hang', onlySubmitted: false, phanTrang: false };
    case HANG_DOI.CHO_DUYET:
      return { kieu: 'tim-kiem', boLoc: 'day-du', onlySubmitted: true, phanTrang: true };
    case HANG_DOI.TAT_CA:
    default:
      return { kieu: 'tim-kiem', boLoc: 'day-du', onlySubmitted: false, phanTrang: true };
  }
}

/**
 * Đọc hàng đợi từ query string, để dán link cho nhau vẫn mở đúng tập.
 * Giá trị lạ, hoặc `cho-duyet` khi không có quyền, đều rơi về `Tất cả` —
 * thà hiện tập rộng hơn còn hơn hiện trang trống không rõ vì sao.
 */
export function docHangDoiTuUrl(giaTri, allowApprove) {
  return hangDoiChoPhep(allowApprove).includes(giaTri) ? giaTri : HANG_DOI.TAT_CA;
}

/**
 * Hàng đợi này có bỏ qua ô tên và ô hạng xe không.
 *
 * Hai hàng đợi kiểm gọi endpoint riêng chỉ nhận hạng khoá, nên hai ô kia không
 * tới được chúng. Giao diện phải khoá hai ô đó lại: để mở là hứa một bộ lọc
 * không chạy, và người dùng sẽ tin vào một danh sách họ tưởng đã lọc.
 */
export function hangDoiBoQuaTen(hangDoi) {
  return truyVanCuaHangDoi(hangDoi).boLoc === 'chi-hang';
}
